import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
`;

export const Wrapper = styled.div`
  width: calc(100% - 60px);
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

export const TabButton = styled.li`
  flex: 1;

  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  transition: color 0.2s ease;

  & > a {
    text-decoration: none;
    font-family: 'GmarketSansMedium', -apple-system, SF Pro Display,
      Helvetica Neue, Apple SD Gothic Neo, Malgun Gothic,
      '\B9D1\C740   \ACE0\B515', sans-serif;
    font-size: 18px;
    color: #333;
    width: 100%;
    height: 100%;
    padding: 15px;
    text-align: center;
  }
  &:after {
    content: '';
    height: 3px;
    will-change: width;
    transition: width 0.2s ease;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    background: #ee1a21;
  }
  ${(props) =>
    props.isSelected &&
    css`
      & > a {
        color: #ee1a21;
      }
      &:after {
        width: 100%;
      }
    `};
`;
